module.exports = __webpack_public_path__ + "static/media/IMAGE-VIRTUAL-AND-LIVE.ea9bf0cd.png";